/* eslint-disable no-constant-condition */
import React, { useEffect, useState } from 'react';
import './ReceptionDetails.less';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { usePackagingFlow } from '../../../context/PackagingFlowContext';
import { BaseModel, PackagingFlowDirection, PackagingFlowItem } from '../../../queries/api/types';
import { usePackagingConfig } from '../../../queries/package';

const ReceptionDetails: React.FC = () => {
    const history = useHistory();
    const [pkgFlowItems, setPkgFlowItems] = useState<PackagingFlowItem[]>([]);
    const { loadingSession, selectedStore, setPackageFlow, packageFlow, packageType, packageCategory } =
        usePackagingFlow();
    const { data: packageConfig } = usePackagingConfig();
    useEffect(() => {
        if (packageConfig && packageFlow) {
            const flowMap: Record<string, PackagingFlowItem> = {};
            const flowItems: PackagingFlowItem[] = [];
            const configModals: Record<string, BaseModel> = {};
            const filterPackages = packageConfig.packages.filter((pkg) => {
                return pkg.type.id === packageType?.id && pkg.category.id === packageCategory?.id;
            });
            filterPackages.forEach((pkg) => {
                const flowItem = packageFlow.packages.find((item) => item.package === pkg.id);
                if (flowItem) {
                    flowMap[pkg.id] = flowItem;
                    flowItems.push(flowItem);
                    configModals[pkg.id] = pkg.model;
                }
            });
            setPkgFlowItems(flowItems);
        }
    }, [packageCategory, packageConfig, packageFlow, packageType]);

    const handleSave = () => {
        if (packageFlow) {
            setPackageFlow({
                ...packageFlow,
                packages: packageFlow.packages.map(
                    (pkg) => pkgFlowItems.find((item) => item.package === pkg.package) || pkg
                ),
            });
        }
        if (
            packageFlow?.flowType === PackagingFlowDirection.RecivedInStore ||
            packageFlow?.flowType === PackagingFlowDirection.ShippedToStore
        ) {
            history.push('/receptionView');
        } else {
            history.push('/recipientMovement');
        }
    };

    const handleCountChange = (
        packageFlowItem: PackagingFlowItem,
        type: 'goodCount' | 'badCount',
        increment: boolean
    ) => {
        const change = increment ? 1 : -1;

        setPkgFlowItems((prevItems) =>
            prevItems.map((item) =>
                item.package === packageFlowItem.package ? { ...item, [type]: Math.max(0, item[type] + change) } : item
            )
        );
    };

    const handleInputChange = (packageFlowItem: PackagingFlowItem, type: 'goodCount' | 'badCount', value: number) => {
        setPkgFlowItems((prevItems) =>
            prevItems.map((item) =>
                item.package === packageFlowItem.package ? { ...item, [type]: Math.max(0, value) } : item
            )
        );
    };

    return (
        <div className="receptionDetails-container">
            <div className="content">
                <header className="header">
                    <div className="location">
                        <p>{selectedStore?.name}</p>
                        <p>Remorque: {loadingSession?.trailerNumber}</p>
                    </div>
                    <div className="info">
                        <p>
                            {moment(loadingSession?.createdAt).format('DD/MM/YYYY')} -{' '}
                            {moment(loadingSession?.createdAt).format(' HH:mm')}
                        </p>
                        <p>Transporteur: {loadingSession?.transporter.name}</p>
                    </div>
                </header>
                {pkgFlowItems.map((flowItem, i) => {
                    const modelName =
                        packageConfig?.packages.find((pkg) => pkg.id === flowItem.package)?.model.name || ''; // Get the model name

                    return (
                        <div key={i} className="quantity-group">
                            <p>
                                <b>{packageType?.name}</b> - {modelName}
                            </p>
                            <div className="border">
                                <div className="quantity">
                                    <span>Bon état:</span>
                                    <div className="quantity-controls">
                                        <MinusOutlined
                                            className="minus"
                                            aria-label="Decrease"
                                            onClick={() => handleCountChange(flowItem, 'goodCount', false)}
                                        />
                                        <input
                                            type="number"
                                            className="input-box"
                                            min="0"
                                            value={flowItem.goodCount}
                                            onChange={(e) =>
                                                handleInputChange(flowItem, 'goodCount', parseInt(e.target.value))
                                            }
                                        />
                                        <PlusOutlined
                                            className="plus"
                                            aria-label="Increase"
                                            onClick={() => handleCountChange(flowItem, 'goodCount', true)}
                                        />
                                    </div>
                                </div>
                                <div className="quantity">
                                    <span>Cassée:</span>
                                    <div className="quantity-controls">
                                        <MinusOutlined
                                            className="minus"
                                            aria-label="Decrease"
                                            onClick={() => handleCountChange(flowItem, 'badCount', false)}
                                        />
                                        <input
                                            type="number"
                                            className="input-box"
                                            min="0"
                                            value={flowItem.badCount}
                                            onChange={(e) =>
                                                handleInputChange(flowItem, 'badCount', parseInt(e.target.value))
                                            }
                                        />
                                        <PlusOutlined
                                            className="plus"
                                            aria-label="Increase"
                                            onClick={() => handleCountChange(flowItem, 'badCount', true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="bottom">
                <footer>
                    <div className="action-buttons">
                        <Button>Reinitialiser</Button>
                        <Button type="primary" onClick={handleSave}>
                            Valider
                        </Button>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default ReceptionDetails;
